export default __webpack_public_path__ + "static/media/ic_aave_40.61003789.svg";